import React from "react";

import dependencyInjection from "@common/util/dependencyInjection";

import { UserFeedbackService } from "./services/UserFeedbackService";
import { ActivityHistoryView, UserFeedbackView } from "./views/UserFeedbackView";

interface Services {
  userFeedbackService: UserFeedbackService;
}

const userFeedbackService = new UserFeedbackService();

const [UserFeedbackDependencyProvider, useUserFeedbackDeps] = dependencyInjection<Services>({
  services: { userFeedbackService },
});

export const UserFeedbackPage = () => (
  <UserFeedbackDependencyProvider>
    <UserFeedbackView />
  </UserFeedbackDependencyProvider>
);

export const UserFeedbackActivityHistoryPage = () => {
  return (
    <UserFeedbackDependencyProvider>
      <ActivityHistoryView />
    </UserFeedbackDependencyProvider>
  );
};

export { useUserFeedbackDeps };
